import { ClearOutlined } from '@mui/icons-material';
import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';

import { useState } from 'react';

import { graphql, type DocumentType } from '@/gql';

import { AssistantDeleteConversationDialog } from './AssistantDeleteConversationDialog';

const ASSISTANT_DELETE_CONVERSATION_BUTTON_CONVERSATION_FRAGMENT = graphql(`
  fragment assistantDeleteConversationButtonConversationFields on OrtooGptConversation {
    ...assistantDeleteConversationDialogConversationFields
    _id
  }
`);

interface Props extends IconButtonProps {
  conversation: DocumentType<
    typeof ASSISTANT_DELETE_CONVERSATION_BUTTON_CONVERSATION_FRAGMENT
  >;
}

export const AssistantDeleteConversationButton = ({
  conversation,
  ...other
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <IconButton
        {...other}
        aria-label="Delete this conversation"
        onClick={() => setDialogOpen(true)}
      >
        <ClearOutlined color="disabled" />
      </IconButton>
      <AssistantDeleteConversationDialog
        conversation={conversation}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
